/*let testimonialsWrapper = document.querySelector('.testimonialsWrapper');
let numberOfElements = document.querySelector('.testimonialsWrapper').childElementCount;
if(numberOfElements<4){
  testimonialsWrapper.removeAttribute("data-flickity");
  testimonialsWrapper.style.display="flex";
}*/

let compareButtonIcon = document.querySelectorAll('.main-products-grid__results .card--product');
compareButtonIcon.forEach(elem =>{
  let fre = elem.querySelector('.compareIconWrapper button');
  let ccc = elem.querySelector('.card__compare input');
  let cccl = elem.querySelector('.card__compare label');
  fre.addEventListener('click', function(){
    ccc.checked = !ccc.checked;
  });
});